import React from 'react';
import PropTypes from 'prop-types';
import { Button, Form, FormGroup } from 'reactstrap';
import { change, Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import FormItem from '../../../common/forms/FormItem';
import { isRequired } from '../../../../utils/validators';
import TextInput from '../../../common/forms/input/TextInput';
import FormFooter from '../../../common/forms/FormFooter';

const validateSecretCode = (confirmSecretCode, { secretCode }) => {
  if (!confirmSecretCode) return undefined;

  return confirmSecretCode !== secretCode
    ? 'Las claves secretas no coinciden'
    : undefined;
};

const validateStrongPassword = (value) => {
  if (!value) return undefined;

  // Explicación del regex:
  // (?=.*[0-9])        -> al menos un número
  // (?=.*[!@#$%^&*])   -> al menos un símbolo especial
  // .{8,}              -> mínimo 8 caracteres
  const regex = /^(?=.*[0-9])(?=.*[!@#$%^&*]).{8,}$/;

  return regex.test(value)
    ? undefined
    : 'La contraseña debe tener mínimo 8 caracteres, incluir números y símbolos especiales';
};

export const CargoCorporateCreditChangePasswordForm = ({
  handleSubmit,
  handleProcess,
  onCancel,
}) => (
  <Form onSubmit={handleSubmit(handleProcess)}>
    <FormGroup row>
      <FormItem label="Nueva Contraseña" required>
        <Field
          className="password"
          name="secretCode"
          component={TextInput}
          type="text"
          placeholder="Nueva Contraseña"
          validate={[isRequired, validateStrongPassword]}
        />
      </FormItem>
    </FormGroup>
    <FormGroup row>
      <FormItem label="Confirmar Contraseña" required>
        <Field
          className="password"
          name="confirmSecretCode"
          component={TextInput}
          type="text"
          placeholder="Confirmar Contraseña"
          validate={[isRequired, validateSecretCode, validateStrongPassword]}
        />
      </FormItem>
    </FormGroup>
    <FormFooter
      saveButtonColor="warning"
      saveButtonIcon="fa fa-key"
      saveButtonText="Cambiar Clave"
    >
      <Button color="primary" onClick={onCancel}>
        Cancelar
      </Button>
    </FormFooter>
  </Form>
);

CargoCorporateCreditChangePasswordForm.propTypes = {
  onCancel: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleProcess: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchChange: change,
};

const formComponent = reduxForm({
  form: 'CargoCorporateCreditChangePasswordForm',
})(CargoCorporateCreditChangePasswordForm);

export default connect(null, mapDispatchToProps)(formComponent);
